import React from "react";
import { Error } from "./index";
import { useField } from "formik";

type PropsType = {
  ariaDescribedBy?: string;
  autoComplete?: string;
  name: string;
  placeholder?: string;
  required?: boolean;
};

type stylesType = {
  touched: boolean;
  error: undefined | string;
};

export function styles({ touched, error }: stylesType) {
  const base = "p-2 w-full border rounded";
  if (touched && error) {
    return base + " border-2 border-red-500";
  } else {
    return base + " border-gray-600";
  }
}

function TextField({
  ariaDescribedBy = "",
  name,
  placeholder,
  autoComplete,
  required = false,
}: PropsType) {
  const [field, { touched, error }] = useField({
    name,
    type: "text",
  });

  const errorId = `${name}ErrorDescription`;
  const calculatedAriaDescribedBy = `${ariaDescribedBy} ${
    error ? errorId : ""
  }`;

  return (
    <>
      <input
        {...field}
        autoComplete={autoComplete}
        aria-describedby={calculatedAriaDescribedBy}
        aria-invalid={error ? "true" : undefined}
        aria-required={required}
        name={name}
        id={name}
        placeholder={placeholder}
        className={styles({ touched, error })}
      />
      <div className="mt-2 md:mt-1">
        {touched && error && <Error id={errorId} errorText={error} />}
      </div>
    </>
  );
}

export default TextField;
